module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Acknowledgments"
    }
  }, [_c('p', {
    staticClass: "fm_h",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#rsec1"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_para"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OR MANY YEARS")]), _vm._v(", I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAVE BENEFITED FROM HAVING")]), _vm._v(" regular opportunities to discuss ancient Greek philosophy with a number of exceptionally gifted specialists, most notably Abraham Schoener, Bernard Freydberg, Ömer Aygün, Gregory Recco, Eric Sanday, Eve Rabinoff, Eli Diamond, Gregory Kirk, Patricia Fagan, James Crooks, Robert Metcalf, and Sean Kirkland. Each of these individuals brings together a rigorous commitment to the ancient texts and a very open and original interpretive perspective, and they all make ancient Greek philosophy a matter of pressing contemporary concern. Being able to think along with these people has been one of the most rewarding dimensions of my life, and I especially want to express my gratitude to them for the role they have played in allowing me to develop my own relationship with ancient Greek philosophy in general and with the "), _c('i', [_vm._v("Republic")]), _vm._v(" in particular (and to Patricia Fagan I owe special thanks for tutoring me in Homeric Greek). My work in this book is also deeply indebted to quite a number of other passionate and insightful interlocutors, most notably Kirsten Jacobson, Whitney Howell, Laura McMahon, Bruce Gilbert, Don Beith, Joe Arel, Nate Andersen, Pete Costello, David Ciavatta, Kym Maclaren, Jeff Morrisey, Susan Bredlau, Brian Rogers, Peter Simpson, Luis Jacob, and Shannon Hoff. These people have been a kind of family to me, and without them I doubt that I could have endured a career in academia. I also benefited immensely from the friendly guidance of Gregory Nagy, when I spent two years in the Department of the Classics at Harvard University as a postdoctoral fellow, and, before that, from the always insightful work of Francis Sparshott, Joseph Owens, and John Rist, who were my teachers during my doctoral studies at the University of Toronto. Finally, I am most especially grateful to John Sallis, with whom I worked at Penn State University for eight years, and who was always very generous with me in ways that had a tremendous impact on my personal and professional life and on my understanding of philosophy. I hope that these individuals at least will find value in this book I have written."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7801f55f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Acknowledgments.vue
// module id = 78
// module chunks = 0